declare namespace $ {

	export class $mynamespace_myapp_logo extends $mol_icon_molecule {
	}
	
}

//# sourceMappingURL=logo.view.tree.d.ts.map